<template>
<div>
    <div class="mb-2">
        <general-print-button @modal-opened="is_printing=true" @modal-closed="is_printing=false"
         print_target="full-report" class="py-1" :btn_variant="'dark-border'"> 인쇄하기 <fa icon="print" class="ml-2"></fa>
        </general-print-button>
    </div>
    <div id="full-report">
        <section class="min-vh-100 bg-white" :class="is_printing==true?'':'mb-5 shadow-md'">
            <report-header></report-header>
            <section class="px-8 py-5" style="min-height: calc(100vh - 145px)">
                <first-page :is_printing="is_printing"  :class="is_printing==true?'':'mb-5'"></first-page>
            </section>
            <report-footer></report-footer>
        </section>
        <section class="min-vh-100 bg-white" :class="is_printing==true?'':'mb-5 shadow-md'">
            <report-header></report-header>
            <section class="px-8 py-5" style="min-height: calc(100vh - 145px)">
                <result-report></result-report>
            </section>
            <report-footer></report-footer>
        </section>
    </div>
</div>
</template>

<script>
import GeneralPrintButton from '@/components/print_to_pdf/GeneralPrintButton'
import ReportHeader from '@/components/supplier_report/ReportHeader'
import ReportFooter from '@/components/supplier_report/ReportFooter'

import FirstPage from '@/components/supplier_report/report_pages/FirstPage'
import ResultReport from '@/components/provider_landing/scm/ResultReport'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    components:{
        GeneralPrintButton,
        ReportHeader,
        ReportFooter,
        FirstPage,
        ResultReport
    },
    data() {
        return {
            is_printing: false,
        }
    },
    computed:{
        ...mapState('score', ['is_score_loaded','is_evaluate_loaded','is_previous_score_loaded', 
        'is_comment_loaded', 'category_names', 'temp_target_companies','previous_temp_target_companies']
        ),
        // ...mapState('industry_scores', ['category2_score', 'company_info', 'industry', 'assessment_info', 'total_score']),
        
    },
    methods:{
        // ...mapMutations('industry_scores', ['update_is_qe_factors_loaded']),
        checkOpened(){
            this.is_printing=true
        }
    },
    created(){
        

    },
    beforeDestroy(){
    }
   
}
</script>

<style>
#full-report {
    font-size: 1.1rem;
    color: var(--gray-900);
}
#full-report p {
    font-weight: 400;
}
.shadow-md{
    box-shadow: 0 0.4rem 0.4rem rgba(0, 0, 0, 0.15) !important;
}
</style>